"use client";

import { type ReactNode } from "react";
import { cn } from "@/lib/cn";

/**
 * A scroll container with the tenant's brand-coloured scrollbar.
 */
export function CustomScroll({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("custom-scroll", className)}>
      {children}
      <style jsx>{`
        .scrollbar-thin {
          overflow-y: auto;
          overflow-x: hidden;
        }

        /* Add the stable scrollbar gutter only if content is scrollable */
        .scrollbar-stable {
          scrollbar-gutter: auto;
        }

        /* WebKit-based browsers (Chrome, Safari, Edge) */
        .scrollbar-thin::-webkit-scrollbar {
          margin-right: 20px;
          width: 8px;
        }

        .scrollbar-thin::-webkit-scrollbar-track {
          background-color: var(--primary);
          border-radius: 10px;
        }

        .scrollbar-thin::-webkit-scrollbar-thumb {
          background-color: var(--primary);
          border-radius: 10px;
          border: 3px solid alpha(from var(--primary) / 13%);
        }

        .scrollbar-thin::-webkit-scrollbar-thumb:hover {
          background-color: var(--primary);
        }

        @supports not (scrollbar-gutter: stable) {
          padding-right: 8px;
          box-sizing: content-box;
        }
      `}</style>
    </div>
  );
}
